module.exports = __webpack_public_path__ + "img/slider_4.28477e6e.jpg";